import { frontendURL } from '../../../helper/URLHelper';

import AiFocusPageRouteView from './pages/AiFocusPageRouteView.vue';
import AgentNewIndex from './assistants/New.vue';

// Lista de agentes (cards)
import AgentsListIndex from './assistants/list/Index.vue';
// Edicao de agente individual
import AgentSettingsIndex from './assistants/settings/Settings.vue';
import AgentInboxesIndex from './assistants/inboxes/Index.vue';
import AgentPlaygroundIndex from './assistants/playground/Index.vue';
// Novas paginas de configuracao
import AgentToolsIndex from './assistants/tools/Index.vue';
import AgentMcpIndex from './assistants/mcp/Index.vue';
import AgentGuardrailsIndex from './assistants/guardrails/Index.vue';

const meta = {
  permissions: ['administrator', 'agent'],
};

const agentRoutes = [
  // Settings = Lista de agents (cards)
  {
    path: frontendURL('accounts/:accountId/ia-agents/settings'),
    component: AgentsListIndex,
    name: 'aifocus_agents_settings_index',
    meta,
  },
  // Edicao de agente individual
  {
    path: frontendURL('accounts/:accountId/ia-agents/:agentId/edit'),
    component: AgentSettingsIndex,
    name: 'aifocus_agents_edit',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/ia-agents/:agentId/playground'),
    component: AgentPlaygroundIndex,
    name: 'aifocus_agents_playground_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/ia-agents/:agentId/inboxes'),
    component: AgentInboxesIndex,
    name: 'aifocus_agents_inboxes_index',
    meta,
  },
  // Ferramentas do agente
  {
    path: frontendURL('accounts/:accountId/ia-agents/:agentId/tools'),
    component: AgentToolsIndex,
    name: 'aifocus_agents_tools_index',
    meta,
  },
  // Servidores MCP
  {
    path: frontendURL('accounts/:accountId/ia-agents/:agentId/mcp'),
    component: AgentMcpIndex,
    name: 'aifocus_agents_mcp_index',
    meta,
  },
  // Guardrails
  {
    path: frontendURL('accounts/:accountId/ia-agents/:agentId/guardrails'),
    component: AgentGuardrailsIndex,
    name: 'aifocus_agents_guardrails_index',
    meta,
  },
  // Criar novo agente
  {
    path: frontendURL('accounts/:accountId/ia-agents/new'),
    component: AgentNewIndex,
    name: 'aifocus_agents_new',
    meta,
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ia-agents'),
    component: AiFocusPageRouteView,
    redirect: to => {
      return {
        name: 'aifocus_agents_settings_index',
        params: to.params,
      };
    },
    children: [...agentRoutes],
  },
];
